<!-- *ngIf="loader.show" -->
<div *ngIf="loader.show" class="loader-main">
    <div class="loader-div-wrapper">
        <div class="loader-image-wrapper">
            <!-- <img src="assets/img/loader.gif" alt="" /> -->
            <img src="assets/images/logo.svg" alt="">
        </div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>